import React, { useState, useEffect } from 'react'
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import Sidebar from '../../../core/common/sidebar/sidebar';
import { Link, useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import ReactApexChart from "react-apexcharts";
import axios from 'axios';
import AlertDashboard from "./components/AlertDashboard";
import DashboardCard from './components/DashboardCard';
import RecentBookingsCard from './components/RecentBookings';
import BookingStatistics from './components/BookingStatistics';

const Dashboard = () => {
    const routes = all_routes

    //Breadcrumb Data
    const breadcrumbs = [
        {
            label: 'Dashboard',
            link: routes.home1,
            active: false,
        },
        {
            label: 'Dashboard',
            active: true,
        },
    ]; 

    return (
        <div>
            <Breadcrumb
                title="Dashboard"
                breadcrumbs={breadcrumbs}
                backgroundClass="breadcrumb-bg-04"
            />

            {/* Page Wrapper */}
            <div className="content content-two">
                <div className="container">
                    <div className="row">
                        {/* Sidebar */}
                        <div className="col-xl-3 col-lg-4 ">
                            <Sidebar />
                        </div>
                        {/* /Sidebar */}
                        <div className="col-xl-9 col-lg-8">
                            <AlertDashboard />
                            <div className="row">
                                <DashboardCard
                                    apiEndpoint="/usuarios/dashboard/total-bookings"
                                    icon="isax-calendar-15"
                                    bgColor="bg-primary"
                                    label="Total Bookings"
                                />
                                <DashboardCard
                                    apiEndpoint="/usuarios/dashboard/total-transactions"
                                    icon="isax-money-send5"
                                    bgColor="bg-secondary"
                                    label="Total Transactions"
                                />
                                <DashboardCard
                                    apiEndpoint="/usuarios/dashboard/average-value"
                                    icon="isax-money-tick5"
                                    bgColor="bg-purple"
                                    label="Average Value"
                                />
                            </div>
                            <div className="row">
                                <RecentBookingsCard />
                                <BookingStatistics />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
